import React, { useEffect, useCallback, useState } from 'react';
import { Col, Row, Card, Form, ButtonGroup, Button } from '@themesberg/react-bootstrap';
import { SUCCESS, APP_NAME, DANGER } from 'utils/constants/notifyTypes';
import 'react-quill/dist/quill.snow.css';
import { apiCall, apiRoutes, convertDate, getToaster, simpleDecrypt } from 'utils/helpers';
import { useDispatch, useSelector } from 'react-redux';
import { eventSingleShowSaga } from 'reduxToolkit/actions/event/eventAction';
import { storeTypes } from '../types';
import { config } from 'config';
import { useParams } from 'react-router-dom';
import { EventStudentTables } from '../components/Event/EventStudentTables';
import { store } from 'react-notifications-component';
import Loader from 'components/Loader';

const EventView = () => {
    const dispatch = useDispatch();
    const { eventId } = useParams<{ eventId: string }>();
    const { eventSingleShowState } = useSelector((state: storeTypes.IStore) => state);
    const { data } = eventSingleShowState;
    const [isLoading, setIsLoading] = useState(false);

    const sendCertificate = useCallback(async () => {
        setIsLoading(true);
        const eventID = data?.id;
        const url = { ...apiRoutes.sendCertificate };
        url.apiPath = url.apiPath.replace(':eventId', eventID ? eventID.toString() : '');
        const response = await apiCall(url);
        if (response?.data?.status) {
            setIsLoading(false);
            store.addNotification(getToaster(`${APP_NAME} Certificate`, response?.data?.message, SUCCESS));
        } else {
            setIsLoading(false);
            store.addNotification(getToaster(`${APP_NAME} Certificate`, response?.data?.error[0], DANGER));
        }
    }, [data]);

    //Watch Params
    useEffect(() => {
        if (eventId) {
            const event_Id = simpleDecrypt(eventId);
            const dispatchPayload = {
                eventId: event_Id,
                type: 'view',
            };
            dispatch(eventSingleShowSaga(dispatchPayload));
        }
    }, [eventId]);

    return (
        <>
            {isLoading ? <Loader isLoad /> : null}
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                <div className="d-block mb-4 mb-md-0">
                    <h4>Event Detail</h4>
                </div>
                <div className="btn-toolbar mb-2 mb-md-0">
                    <ButtonGroup>
                        <a href="/events">
                            <Button variant="outline-primary" size="sm">
                                Back
                            </Button>
                        </a>
                    </ButtonGroup>
                </div>
            </div>

            <Row>
                <Col xs={12} xl={8}>
                    <Card border="light" className="bg-white shadow-sm mb-4">
                        <Card.Body>
                            {/* Title and description */}
                            <Row>
                                <Col md={12} className="mb-3">
                                    <Form.Group id="firstName">
                                        <Form.Label>
                                            <b>Title</b>
                                        </Form.Label>
                                        <Card.Text>{data?.title}</Card.Text>
                                    </Form.Group>
                                </Col>

                                <Col md={12} className="mb-3">
                                    <Form.Group id="firstName">
                                        <Form.Label>
                                            <b>Short Description</b>
                                        </Form.Label>

                                        <Card.Text>{data?.short_description}</Card.Text>
                                    </Form.Group>
                                </Col>
                                <Col md={12} className="mb-3">
                                    <Form.Group id="firstName">
                                        <Form.Label>
                                            <b>Long Description</b>
                                        </Form.Label>
                                        <Card.Text
                                            dangerouslySetInnerHTML={{
                                                __html: data?.description || '',
                                            }}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            {/* Start and end date */}
                            <Row className="align-items-center">
                                <Col md={6} className="mb-3">
                                    <Form.Group id="birthday">
                                        <Form.Label>
                                            <b>Start Date and Time</b>
                                        </Form.Label>
                                        <Card.Text>
                                            {convertDate(data?.start_date, 'DD-MM-YYYY')} {'- '}
                                            {convertDate(`${data?.start_date}T${data?.start_time}:00.000Z`, 'hh:mm A')}
                                        </Card.Text>
                                    </Form.Group>
                                </Col>

                                <Col md={6} className="mb-3">
                                    <Form.Group id="birthday">
                                        <Form.Label>
                                            <b>End Date and Time</b>
                                        </Form.Label>
                                        <Card.Text>
                                            {convertDate(data?.end_date, 'DD-MM-YYYY')} {'- '}
                                            {convertDate(`${data?.end_date}T${data?.end_time}:00.000Z`, 'hh:mm A')}
                                        </Card.Text>
                                    </Form.Group>
                                </Col>
                            </Row>

                            {/* Fees and Offer */}
                            <Row>
                                <Col md={6} className="mb-3">
                                    <Form.Group id="firstName">
                                        <Form.Label>
                                            <b>Fees</b>
                                        </Form.Label>
                                        <Card.Text>{data?.fees}</Card.Text>
                                    </Form.Group>
                                </Col>
                                <Col md={6} className="mb-3">
                                    <Form.Group id="lastName">
                                        <Form.Label>
                                            <b>Offer Price</b>
                                        </Form.Label>
                                        <Card.Text>{data?.offer}</Card.Text>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6} className="mb-3">
                                    <Form.Group id="gender">
                                        <Form.Label>
                                            <b>Type</b>
                                        </Form.Label>
                                        <Card.Text>{data?.type}</Card.Text>
                                    </Form.Group>
                                </Col>
                                <Col md={6} className="mb-3">
                                    <Form.Group id="firstName">
                                        <Form.Label>
                                            <b>Who can attend</b>
                                        </Form.Label>
                                        <Card.Text>{data?.who_can_attend}</Card.Text>
                                    </Form.Group>
                                </Col>
                                <Col md={6} className="mb-3">
                                    <Form.Group id="firstName">
                                        <Form.Label>
                                            <b>Duration (In Days)</b>
                                        </Form.Label>
                                        <Card.Text>{data?.duration} Days</Card.Text>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>

                <Col xs={12} xl={4}>
                    <Row>
                        <Col xs={12}>
                            <Form.Group controlId="formFile" className="mb-3">
                                <Form.Label>
                                    <b>Image</b>
                                </Form.Label>
                            </Form.Group>

                            {data?.file_path ? (
                                <Card border="light" className="text-center p-0 mb-4">
                                    <div
                                        style={{ backgroundImage: `url(${config.apiBaseURL}/${data?.file_path})` }}
                                        className="profile-cover rounded-top"
                                    />
                                </Card>
                            ) : null}
                        </Col>
                    </Row>
                </Col>
            </Row>

            <Row>
                <div className="d-block mb-4 mb-md-0">
                    <h4>
                        Student Details{' '}
                        <Button onClick={() => sendCertificate()} variant="outline-primary" size="sm">
                            Send Certificate
                        </Button>
                    </h4>
                </div>
                <Col xs={12} xl={12}>
                    <EventStudentTables />
                </Col>
            </Row>
        </>
    );
};

export default EventView;
